import React from "react";
import { EmptyDataImage } from "../../../../../../../asset";

const TableReportOrderNoData = ({ openFilter }) => {
  return (
    <>
      <div className="container-table-report-no-data">
        <div className="container-header-no-data">
          <span className="span-header-no-data ml-4 ">Depot</span>
          <span className="span-header-no-data">Order Date</span>
          <span className="span-header-no-data">Order From</span>
          <span className="span-header-no-data">Order ID</span>
          <span className="span-header-no-data">Order Number</span>
          <span className="span-header-no-data">Order Status</span>
          <span className="span-header-no-data">Delivery Type</span>
          <span className="span-header-no-data">Customer ID</span>
          <span className="span-header-no-data">Customer Name</span>
          <span className="span-header-no-data">Country</span>
          <span className="span-header-no-data">Province</span>
          <span className="span-header-no-data">District</span>
          <span className="span-header-no-data">Sub District</span>
          <span className="span-header-no-data">Urban Village</span>
          <span className="span-header-no-data">Postal Code</span>
          <span className="span-header-no-data">Longitude</span>
          <span className="span-header-no-data">Lattitude</span>
          <span className="span-header-no-data">Total SI</span>
          <span className="span-header-no-data">Total Item</span>
          <span className="span-header-no-data">Shipping Cost</span>
          <span className="span-header-no-data">Order Price</span>
          <span className="span-header-no-data">Total Weight</span>
          <span className="span-header-no-data">Total Volume</span>
        </div>
        <div className="container-empty-data-table">
          <img src={EmptyDataImage} alt="empty data" />
          <span className="span-no-data-available">No Data Available</span>
          <div
            onClick={openFilter}
            className="container-klik-filter-from-table"
          >
            <span className="underline underline-offset-2">
              Click here to Open the Filter
            </span>
            <span className="underline underline-offset-2">
              and select all data that you want to export
            </span>
          </div>
        </div>
      </div>
      <div className="w-full h-[50px] rounded-b-3xl bg-[#EAEAEA]"></div>
    </>
  );
};

export default TableReportOrderNoData;
